import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-dt";

const datatable = () => {
    const init = () => {
        clientSide();
    };

    const el = {
        clientSide: ".js-datatable-client-side",
    };

    const clientSide = () => {
        if ($(el.clientSide).length === 0) return;

        const searching = $(el.clientSide).data("searching");
        const lengthChange = $(el.clientSide).data("length_change");
        const info = $(el.clientSide).data("info");
        const paging = $(el.clientSide).data("paging");
        /**
         * @type {"numbers" | "simple" | "simple_numbers" | "full" | "full_numbers" | "first_last_numbers"}
         */
        const pagingType =
            $(el.clientSide).data("paging_type") ?? "simple_numbers";

        $(window).on("load", () => {
            $(el.clientSide).DataTable({
                searching,
                lengthChange,
                info,
                paging,
                pagingType,
                autoWidth: false,
                order: [],
                columnDefs: [
                    {
                        targets: "no-sort",
                        orderable: false,
                    },
                ],
                language: {
                    paginate: {
                        next: '<span class="next"></span>',
                        previous: '<span class="prev"></span>',
                    },
                },
                scrollX: true,
                scrollCollapse: true,
                fixedColumns: true,
            });
        });
    };
    init();
};

try {
    datatable();
} catch (error) {
    console.error("datatable", error);
}
